<template>
  <div class="limiter">
    <div class="container-login100 bg-login">
      <div class="wrap-login100 p-l-100 p-r-100 p-t-50 p-b-50">
        <template v-if="displayElement == 'login'">
          <login></login>
        </template>
        <template v-else-if="displayElement == 'signup'">
          <signup></signup>
        </template>
        <template v-else-if="displayElement == 'recovery-password'">
          <recovery-password></recovery-password>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Login from './client/Login.vue'
import Signup from './client/Signup.vue'
import RecoveryPassword from './client/RecoveryPassword.vue'
import { xMisc } from '@/mixins/xMisc.js'
export default {
  name: 'performance',
  mixins: [xMisc],
  data () {
    return {
      displayElement: null,
      email: null
    }
  },
  props: {
    theme: {type: String, default: 'login'}
  },
  watch: {
    '$route' (to, from) {
      this.start()
      this.setForm(to.name)
      this.$Progress.finish()
    }
  },
  created () {
    this.setForm()
  },
  methods: {
    setForm (target = null) {
      if (target !== null) {
        this.displayElement = target
      } else {
        this.displayElement = this.theme
      }
    }
  },
  components: {
    Login,
    Signup,
    RecoveryPassword
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Performance.vue